<app-modal
	[title]="'TRANSFER' | translate"
	#eTicketTransfertModal
	[showModal]="showModalTransfert"
	modalWidth="50"
	(closeModalFrom2NDParent)="showModalTransfert = false">
	<div class="col-md-12 col-xs-12 col-sm-12 text-center" *ngIf="showModalTransfert">
		<div class="color-4 col-md-12 col-sm-12 col-xs-12 clear-padding">
			<label class="margin-15-b">
				{{ "AGENCY" | translate }}
			</label>
			<br />
			<app-shared-commun-dropdown
				[searchSource]="'agency-panel'"
				[mainButtonID]="'flight_manage_bookings_agencies_dropdown'"
				[mainButtonText]="agenciesListText[0]"
				[dropdownAriaID]="'flight_manage_bookings_agencies_dropdown_aria'"
				[ariaButtonsID]="agenciesListID"
			 	[ariaButtonsText]="agenciesListText"
				(clickEvent)="getSelectedAgency($event)"
				[useShowDropdownMenu]="true">
			</app-shared-commun-dropdown>
		</div>

		<div class="col-md-12 col-sm-12 col-xs-12 text-center login-form" style="padding: 0">
			<button
				style="margin: 40px"
				[disabled]="selectedAgencyIndex == null"
				(click)="transfertTicket()">
				{{ "CONTINUE" | translate }}
			</button>
		</div>
	</div>
</app-modal>

<app-flight-voucher-shared
	*ngIf="modalElement"
	[(modalElement)]="modalElement"
	[pageType]="'ticket'"
	[tripType]="tripType"
	(printTicketEvent)="printTicket($event)"
	(sendTicketEmailEvent)="sendBookingByEmail($event)"
	(confirmBookingEvent)="confirmBooking()"
	(transfertTicketEvent)="openTransfertTicket()"
	(synchronizeEvent)="synchronize()"
	(refundEticketEvent)="refundEticket()"
	(cancelEticketEvent)="cancelEticket()"
	(applyPenaltyCancelTicketAdminEvent)="applyPenaltyCancelTicketAdmin($event)">
</app-flight-voucher-shared>

<section>
	<div class="row page-title">
	</div>
</section>
<div *ngIf="errorMessage" style="height: 70dvh;display: flex;align-items: self-start;width: 100%;padding: 20px;">
	<p class="alert alert-danger" style="width:100% ;">{{ errorMessage | translate }}</p>
</div>
